/**
 * RefreshButton — Bouton d'actualisation universel dans les topbars des back-offices.
 *
 * Cas d'usage : quand un élève / enseignant / admin veut s'assurer d'avoir la dernière
 * version des données (nouvel élève rattaché via QR, nouveau bilan écrit par le moniteur,
 * planning central mis à jour par le secrétariat, etc.).
 *
 * Un clic → recharge complète de la page (window.location.reload).
 * Animation de rotation pendant 400ms pour retour visuel.
 * Raccourci clavier: Ctrl/Cmd + R (natif navigateur — pas de conflit).
 */
import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';

export function RefreshButton({ variant = 'moniteur', className = '' }) {
  const [spinning, setSpinning] = useState(false);

  const doRefresh = () => {
    setSpinning(true);
    // Laisse l'animation démarrer avant le reload
    setTimeout(() => window.location.reload(), 300);
  };

  const themes = {
    admin: 'border-red-500/25 bg-red-500/[0.06] hover:bg-red-500/[0.12] text-red-200 hover:text-white',
    moniteur: 'border-rose-500/25 bg-rose-500/[0.06] hover:bg-rose-500/[0.12] text-rose-200 hover:text-white',
    eleve: 'border-rose-500/25 bg-rose-500/[0.06] hover:bg-rose-500/[0.12] text-rose-200 hover:text-white',
    secretariat: 'border-orange-500/25 bg-orange-500/[0.06] hover:bg-orange-500/[0.12] text-orange-200 hover:text-white',
  };
  const theme = themes[variant] || themes.moniteur;

  return (
    <button
      onClick={doRefresh}
      disabled={spinning}
      title="Actualiser la page pour voir les dernières données"
      aria-label="Actualiser"
      data-testid={`refresh-btn-${variant}`}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg border text-[11.5px] font-semibold transition disabled:opacity-70 disabled:cursor-wait ${theme} ${className}`}
    >
      <RefreshCw size={12} className={spinning ? 'animate-spin' : ''} />
      <span className="hidden sm:inline">{spinning ? 'Actualisation…' : 'Actualiser'}</span>
    </button>
  );
}

export default RefreshButton;
